import { toast } from "react-toastify";
import api from "api/api";

export const GET_CASH_REGISTERS_BY_YEAR_MONTH = "[CASH REGISTER] GET CASH REGISTERS BY MONTH YEAR";
export const GET_CASH_REGISTER_OPENINGS = "[CASH REGISTER] GET CASH REGISTER OPENINGS";
export const SAVE_CASH_REGISTER_OPENING = "[CASH REGISTER] SAVE CASH REGISTER OPENING";
export const SAVE_CASH_REGISTER_CLOSING = "[CASH REGISTER] SAVE CASH REGISTER CLOSING";
export const GET_CASH_REGISTER_MOVEMENTS = "[CASH REGISTER] GET CASH REGISTER MOVEMENTS";
export const GET_CASH_REGISTER_TOTALS = "[CASH REGISTER] GET CASH REGISTER TOTALS";
export const RESET_CASH_REGISTER_TOTALS = "[CASH REGISTER] RESET CASH REGISTER TOTALS";

export function getCashRegistersByYearMonthAction(yearMonth) {
  const request = api.get(`/cash-registers/by-year-month/${yearMonth}`);
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTERS_BY_YEAR_MONTH, payload: { loading: true } });
    request
      .then(({ data }) => {
        dispatch({ type: GET_CASH_REGISTERS_BY_YEAR_MONTH, payload: { data: data.data } });
      })
      .catch((error) => {
        console.log(GET_CASH_REGISTERS_BY_YEAR_MONTH, error);
      })
      .finally(() => {
        dispatch({ type: GET_CASH_REGISTERS_BY_YEAR_MONTH, payload: { loading: false } });
      });
  };
}

export function getCashRegisterOpeningsAction() {
  const request = api.get("/cash-registers/openings");
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTER_OPENINGS, payload: { loading: true } });
    request
      .then((response) => {
        dispatch({ type: GET_CASH_REGISTER_OPENINGS, payload: { data: response.data.data } });
      })
      .catch((error) => {
        console.log(GET_CASH_REGISTER_OPENINGS, error);
      })
      .finally(() => {
        dispatch({ type: GET_CASH_REGISTER_OPENINGS, payload: { loading: false } });
      });
  };
}

export function saveCashRegisterOpeningAction(data) {
  const request = api.post("/cash-registers/save-opening", data);
  return (dispatch) => {
    dispatch({ type: SAVE_CASH_REGISTER_OPENING, payload: { saving: true } });
    request
      .then(({ data }) => {
        if (Number(data.status) !== 200) {
          toast.error(data.message);
          return;
        }
        dispatch({ type: SAVE_CASH_REGISTER_OPENING, payload: { saved: true, data: data.data } });
        toast.success(data.message);
      })
      .catch((error) => {
        console.log(SAVE_CASH_REGISTER_OPENING, error);
      })
      .finally(() => {
        dispatch({ type: SAVE_CASH_REGISTER_OPENING, payload: { saving: false } });
      });
  };
}

export function saveCashRegisterClosingAction(data) {
  const request = api.post("/cash-registers/save-closing", data);
  return (dispatch) => {
    dispatch({ type: SAVE_CASH_REGISTER_CLOSING, payload: { saving: true } });
    request
      .then(({ data }) => {
        if (Number(data.status) !== 200) {
          toast.error(data.message);
          return;
        }
        dispatch({ type: SAVE_CASH_REGISTER_CLOSING, payload: { saved: true, data: data.data } });
        toast.success(data.message);
      })
      .catch((error) => {
        console.log(SAVE_CASH_REGISTER_CLOSING, error);
      })
      .finally(() => {
        dispatch({ type: SAVE_CASH_REGISTER_CLOSING, payload: { saving: false } });
      });
  };
}

export function getCashRegisterMovementsAction(cashRegisterId) {
  const request = api.get(`/cash-registers/${cashRegisterId}/movements`);
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { loading: true } });
    request
      .then(({ data }) => {
        dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { data: data.data } });
      })
      .catch((error) => {
        console.log(GET_CASH_REGISTER_MOVEMENTS, error);
      })
      .finally(() => {
        dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { loading: false } });
      });
  };
}

export function getCashRegisterTotalsAction(cashRegisterId) {
  const request = api.get(`/cash-registers/${cashRegisterId}/totals`);
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTER_TOTALS, payload: { loading: true } });
    request
      .then(({ data }) => {
        dispatch({ type: GET_CASH_REGISTER_TOTALS, payload: { data: data.data } });
      })
      .catch((error) => {
        console.log(GET_CASH_REGISTER_TOTALS, error);
      })
      .finally(() => {
        dispatch({ type: GET_CASH_REGISTER_TOTALS, payload: { loading: false } });
      });
  };
}
